import { apiRequest } from "./_api";

export async function postCompany(
  postCompanyDto: CreateCompanyDto
): Promise<ReadCompanyDto> {
  return await apiRequest<ReadCompanyDto>(
    "post",
    `/companiesHeads/create`,
    postCompanyDto
  );
}

export async function getCompaniesListAndSearch(
  page: number,
  itemsPerPage: number,
  search?: string
): Promise<ListCompaniesDto> {
  let query = "?";
  query += page ? `page=${page}&` : "";
  query += itemsPerPage ? `itemsPerPage=${itemsPerPage}&` : "";
  query += search ? `search=${search}` : "";

  return await apiRequest<ListCompaniesDto>(
    "get",
    `/companiesHeads/list${query}`
  );
}

export async function getByUuidCompany(uuid: string): Promise<ReadCompanyDto> {
  let query = "?";
  query += uuid ? `uuid=${uuid}` : "";

  return await apiRequest<ReadCompanyDto>(
    "get",
    `/companiesHeads/find-by-uuid${query}`
  );
}

export async function getByNameCompany(name: string): Promise<ReadCompanyDto> {
  let query = "?";
  query += name ? `name=${name}` : "";

  return await apiRequest<ReadCompanyDto>(
    "get",
    `/companiesHeads/find-by-name${query}`
  );
}

export async function selectCompanies(): Promise<SelectCompanyDto[]> {
  return await apiRequest<SelectCompanyDto[]>("get", `/companiesHeads/select`);
}

export async function getLanguageByDomain(): Promise<ReadLanguageCompanyDto> {
  return await apiRequest<ReadLanguageCompanyDto>(
    "get",
    `/companiesHeads/find-language`
  );
}

export async function putCompany(
  uuid: string,
  putCompanyDto: UpdateCompanyDto
): Promise<ReadCompanyDto> {
  let query = "?";
  query += uuid ? `uuid=${uuid}` : "";

  return await apiRequest<ReadCompanyDto>(
    "put",
    `/companiesHeads/update${query}`,
    putCompanyDto
  );
}

export async function deleteCompany(uuid: string): Promise<DeleteDto> {
  let query = "?";
  query += uuid ? `uuid=${uuid}` : "";

  return await apiRequest<DeleteDto>(
    "delete",
    `/companiesHeads/soft-delete${query}`
  );
}
